import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import { ModelPreset } from "./dto/preset.dto";

import { PresetRepository } from "./preset.repository";


export class PresetService extends BaseService {
  private presetRepository = new PresetRepository(this.api, this.configService);

  async getPreset(): Promise<ModelPreset[]> {
    let dataResult: ModelPreset[] = [];
    try {
      const { $functions } = useNuxtApp()
      const res = await this.presetRepository.getPreset();
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map(e => new ModelPreset(e))
        console.log('getPreset', resData.data, dataResult)
      }
    } catch (err) {
      console.log(err, PresetService.name);
    }
    return dataResult;
  }

  async getPresetDetail(id: string | number): Promise<ModelPreset> {
    let dataResult: ModelPreset = new ModelPreset();
    try {
      const { $functions } = useNuxtApp()
      const res = await this.presetRepository.getPresetDetail(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelPreset(resData.data)
        console.log('getPresetDetail', resData.data, dataResult)
      }
    } catch (err) {
      console.log(err, PresetService.name);
    }
    return dataResult;
  }

  async getPresetFile(fileName: string): Promise<any> {
    let dataResult;
    try {
      const res = await this.presetRepository.getPresetFile(fileName);
      const resData = res.data.value;
      if (resData) {
        dataResult = resData;
        console.log('getPresetFile', fileName, resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, PresetService.name);
    }
    return dataResult;
  }

  // async getUserDetail(params: IModelRequestUserDetail): Promise<IModelUser> {
  //   let dataResult: IModelUser = new ModelUser();
  //   try {
  //     const { $functions } = useNuxtApp()
  //     const res = await this.presetRepository.getUserDetail(params);
  //     const resData = res.data.value;
  //     if ($functions.isValidResponse(resData)) {
  //       dataResult = new ModelUser(resData.data)
  //       console.log('getUserDetail', resData.data, dataResult)
  //     }
  //   } catch (err) {
  //     console.log(err, UserService.name);
  //   }
  //   return dataResult;
  // }

  // async createUser(params: IModelRequestManageUserDetail): Promise<IModelResponse> {
  //   let dataResult: IModelResponse = new ModelResponse();
  //   try {
  //     // mock response api create
  //     dataResult.message = ENUM.API_RESPONSE_MESSAGE.SUCCESS
  //   } catch (err) {
  //     console.log(err, UserService.name);
  //   }
  //   return dataResult;
  // }

  // async updateUser(params: IModelRequestManageUserDetail): Promise<IModelResponse> {
  //   let dataResult: IModelResponse = new ModelResponse();
  //   try {
  //     // mock response api update
  //     dataResult.message = ENUM.API_RESPONSE_MESSAGE.SUCCESS
  //   } catch (err) {
  //     console.log(err, UserService.name);
  //   }
  //   return dataResult;
  // }
}
